import { render, staticRenderFns } from "./BookingPageEmptyState.vue?vue&type=template&id=667593d1&scoped=true&"
import script from "./BookingPageEmptyState.vue?vue&type=script&lang=js&"
export * from "./BookingPageEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./BookingPageEmptyState.vue?vue&type=style&index=0&id=667593d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667593d1",
  null
  
)

export default component.exports